export default __webpack_public_path__ + "static/04.02-c4e96c46c6907a949ddcd8dfa8847ec2.png";